import { Dimensions, Platform } from 'react-native';

export const BREAKPOINTS = {
  mobile: 480,    // Updated to cover phones and small tablets
  tablet: 768,   // Updated for larger tablets/iPads
  laptop: 1440,   // Kept same for laptops
  desktop: 1920,  // Updated to modern 1080p+ displays
};

export const getWindowWidth = () => {
  if (Platform.OS === 'web') {
    // On web, use window.innerWidth for more consistent results
    return typeof window !== 'undefined' ? window.innerWidth : Dimensions.get('window').width;
  }
  return Dimensions.get('window').width;
};

export const isScreenSize = (size) => {
  const width = getWindowWidth();
  switch (size) {
    case 'mobile':
      return width <= BREAKPOINTS.mobile;
    case 'tablet':
      return width > BREAKPOINTS.mobile && width <= BREAKPOINTS.tablet;
    case 'laptop':
      return width > BREAKPOINTS.tablet && width <= BREAKPOINTS.laptop;
    case 'desktop':
      return width > BREAKPOINTS.laptop;
    default:
      return false;
  }
};

export const getResponsiveValue = (values) => {
  const width = getWindowWidth();
  
  // Ensure we have values for all breakpoints
  const defaultValues = {
    mobile: values.mobile || values.tablet || values.laptop || values.desktop,
    tablet: values.tablet || values.laptop || values.desktop || values.mobile,
    laptop: values.laptop || values.desktop || values.tablet || values.mobile,
    desktop: values.desktop || values.laptop || values.tablet || values.mobile,
  };

  if (width <= BREAKPOINTS.mobile) return defaultValues.mobile;
  if (width <= BREAKPOINTS.tablet) return defaultValues.tablet;
  if (width <= BREAKPOINTS.laptop) return defaultValues.laptop;
  return defaultValues.desktop;
};

// Helper function to create responsive styles
export const createResponsiveStyle = (property, values) => {
  const width = getWindowWidth();
  const defaultValues = {
    mobile: values.mobile || values.tablet || values.laptop || values.desktop,
    tablet: values.tablet || values.laptop || values.desktop || values.mobile,
    laptop: values.laptop || values.desktop || values.tablet || values.mobile,
    desktop: values.desktop || values.laptop || values.tablet || values.mobile,
  };

  if (width <= BREAKPOINTS.mobile) return { [property]: defaultValues.mobile };
  if (width <= BREAKPOINTS.tablet) return { [property]: defaultValues.tablet };
  if (width <= BREAKPOINTS.laptop) return { [property]: defaultValues.laptop };
  return { [property]: defaultValues.desktop };
}; 